import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ConfirmDialog } from './confirm-dialog';

interface RegenerateWithAudioDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/** What the organizer gives up by replacing the text-only transcript with the audio one. */
export const RegenerateWithAudioDialog: FC<RegenerateWithAudioDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={t('meeting-secretary.meetings.transcript-regenerate-title')}
      confirmLabel={t('meeting-secretary.meetings.transcript-regenerate-confirm')}
    >
      {/* Light body text, as in the banners; only the phrases that matter are bold. */}
      <p className="text-[var(--ds-color-text-secondary)]">
        <Trans
          i18nKey="meeting-secretary.meetings.transcript-regenerate-message"
          components={{
            strong: <strong className="font-semibold text-[var(--ds-color-text-primary)]" />,
          }}
        />
      </p>
    </ConfirmDialog>
  );
};
